(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["td-product-modal"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('td-product-modal')) {
    class TDProductModal extends HTMLElement {
      constructor() {
        super();
        
        this.SECTION_NAME = 'td-product-modal';
        
        // Product state
        this.currentProductHandle = null;
        this.isLoading = false;
        this.isAddToCartLoading = false;

        // Bound references for removeEventListener (must match addEventListener)
        this.boundHandleQuickViewClick = this.handleQuickViewClick.bind(this);
        this.boundCloseModal = this.closeModal.bind(this);
      }
      
      connectedCallback() {
        this.modal = this.querySelector('[data-modal]');
        this.modalInner = this.querySelector('.td-product-modal__inner');
        this.contentWrapper = this.querySelector('.td-product-modal__content-wrapper');
        this.loadingElement = this.querySelector('[data-loading]');
        this.closeButtons = this.querySelectorAll('[data-close-modal]');

        this.setupListeners();
        if (this.querySelector('[data-variant-select]')) {
          this.initializeProductListeners();
        }
      }
      
      setupListeners() {
        document.addEventListener('quick-view-button-click', this.boundHandleQuickViewClick);

        if (this.closeButtons && this.closeButtons.length > 0) {
          this.closeButtons.forEach(button => {
            button.addEventListener('click', this.boundCloseModal);
          });
        }
      }
      
      initializeProductListeners() {
        const variantSelect = this.querySelector('[data-variant-select]');
        const addToCartButton = this.querySelector('[data-add-to-cart]');
        
        if (variantSelect) {
          variantSelect.addEventListener('change', this.handleVariantChange.bind(this));
        }
        if (addToCartButton) {
          addToCartButton.addEventListener('click', this.handleAddToCartClick.bind(this), true);
        }
      }

      disconnectedCallback() {
        document.removeEventListener('quick-view-button-click', this.boundHandleQuickViewClick);

        if (this.closeButtons && this.closeButtons.length > 0) {
          this.closeButtons.forEach(button => {
            button.removeEventListener('click', this.boundCloseModal);
          });
        }
      }
      
      handleAddToCartClick(event) {
        this.closeModal();
      }
      
      async handleQuickViewClick(event) {
        event.preventDefault();
        const productHandle = event.detail?.productHandle;
        
        if (!productHandle) {
          console.error('TD Product Modal: No product handle provided');
          return;
        }
        
        if (this.isLoading) {
          return;
        }
        
        await this.loadProduct(productHandle);
      }
      
      async loadProduct(productHandle) {
        this.isLoading = true;
        this.showLoading();    
        
        try {
          this.currentProductHandle = productHandle;
          let url = window.Shopify.routes.root + `products/${productHandle}?section_id=${this.SECTION_NAME}`;
          
          const response = await fetch(url);

          if (!response.ok) {
            throw new Error(`Failed to load product: ${response.statusText}`);
          }
                    
          // Parse the HTML response
          const html = await response.text();
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const responseModal = doc.querySelector('#td-product-modal');
          const responseContentWrapper = responseModal?.querySelector('.td-product-modal__content-wrapper');

          if (this.contentWrapper && responseContentWrapper) {
            this.contentWrapper.innerHTML = responseContentWrapper.innerHTML;
            this.initializeProductListeners();
          }
          
          this.hideLoading();
          this.openModal();
          
        } catch (error) {
          console.error('TD Product Modal: Error loading product', error);
          this.hideLoading();
          document.dispatchEvent(new CustomEvent('modal:open'));
        } finally {
          this.isLoading = false;
        }
      }

      handleVariantChange(event) {
        event.preventDefault();
        const variantSelect = event.target;
        const selectedOption = variantSelect.options[variantSelect.selectedIndex];
        
        if (!selectedOption) {
          return;
        }
        
        const price = selectedOption.dataset.price;
        const compareAtPrice = selectedOption.dataset.compareAtPrice;
        const isAvailable = selectedOption.dataset.available === 'true';
        const imageUrl = selectedOption.dataset.imageUrl;
        const imageAlt = selectedOption.dataset.imageAlt;
        const priceCurrent = this.querySelector('[data-price-current]');
        const priceCompare = this.querySelector('[data-price-compare]');
        
        if (priceCurrent && price) {
          priceCurrent.textContent = price;
        }
        
        // Show compare price only if it exists and is different from current price
        if (priceCompare) {
          if (compareAtPrice && compareAtPrice !== price && compareAtPrice !== '0' && compareAtPrice !== '$0.00') {
            priceCompare.textContent = compareAtPrice;
            priceCompare.style.display = 'inline';
          } else {
            priceCompare.style.display = 'none';
          }
        }
        
        // Update image
        if (imageUrl) {
          const imageSection = this.querySelector('.td-product-modal__image img');
          if (imageSection) {
            imageSection.src = imageUrl;
            imageSection.srcset = '';
            if (imageAlt) {
              imageSection.alt = imageAlt;
            }
          }
        }
        
        // Update add to cart button
        const addToCartButton = this.querySelector('[data-add-to-cart]');
        const buttonText = addToCartButton && addToCartButton.querySelector('span[data-add-to-cart-text]');
        
        if (addToCartButton) {
          addToCartButton.disabled = !isAvailable;
          
          if (buttonText) {
            const addToCartText = addToCartButton.getAttribute('data-add-to-cart-text') || 'Add to cart';
            const soldOutText = addToCartButton.getAttribute('data-sold-out-text') || 'Sold out';
            buttonText.textContent = isAvailable ? addToCartText : soldOutText;
          }
        }
        
        // Clear any errors
        this.hideError();
      }
      
      showLoading() {
        if (this.loadingElement) {
          this.loadingElement.style.display = 'flex';
        }
        if (this.contentWrapper) {
          this.contentWrapper.style.display = 'none';
        }
      }
      
      hideLoading() {
        if (this.loadingElement) {
          this.loadingElement.style.display = 'none';
        }
        if (this.contentWrapper) {
          this.contentWrapper.style.display = 'block';
        }
      }

      hideError() {
        const errorEl = this.querySelector('[data-product-modal-error]');
        if (errorEl) {
          errorEl.style.display = 'none';
          errorEl.textContent = '';
        }
      }
      
      openModal() {
        if (this.modal && !this.modal.classList.contains('td-product-modal--open')) {
          const titleEl = this.querySelector('.td-product-modal__title');
          if (titleEl) {
            this.modal.setAttribute('aria-label', titleEl.textContent.trim() || 'Product details');
          }

          this.modal.classList.add('td-product-modal--open');
          document.body.style.overflow = 'hidden';
          document.dispatchEvent(new CustomEvent('modal:open'));
        }
      }
      
      closeModal() {
        if (this.modal) {
          this.modal.classList.remove('td-product-modal--open');
          document.body.style.overflow = '';
        }
      }
    }
    
    customElements.define('td-product-modal', TDProductModal);
  }
  } catch(e) { console.error(e); }
})();

})();
